export interface Dependent {
  deps: Array<unknown>;
}

export class DependentImpl implements Dependent {
  readonly deps: Array<unknown>;

  constructor(deps: Array<unknown>);
  constructor(...deps: unknown[]);
  constructor(...args: unknown[]) {
    // Normalize: if a single array is passed, use it; otherwise use all args
    this.deps =
      args.length === 1 && Array.isArray(args[0])
        ? (args[0] as unknown[])
        : args;
  }
}
